import type { InterventionType } from '@dhl/interventions'

export const paths = {
  CONSOLIDATED_INTERVENTIONS: 'consolidated',
  CONFIRM: 'confirm',
}

type ConsolidatedInterventionParams = {
  ids: string
  postalCode: string
  type?: InterventionType
}

export const interventionLinks = {
  consolidatedIntervention: (): string => `/${paths.CONSOLIDATED_INTERVENTIONS}`,
  consolidatedInterventionDetail: ({ ids, postalCode }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}/${postalCode}`,
  consolidatedInterventionDetailType: ({ ids, postalCode, type }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}/${postalCode}/${type}`,
  consolidatedInterventionDetailConfirm: ({ ids, postalCode }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}/${postalCode}/${paths.CONFIRM}`,
}

export type InterventionLinks = typeof interventionLinks
